import React, { useEffect, useMemo } from "react";
import { useFormikContext, ErrorMessage, Field } from "formik";
import { RadioButton } from "primereact/radiobutton";

interface RadioOption {
  label?: string;
  value: any;
}

const RadioButtonComponent: React.FC<any> = (props) => {
  const { name, label, options, ...rest } = props;

  const { setFieldTouched, isSubmitting } = useFormikContext();

  useEffect(() => {
    if (!isSubmitting) return;
    setFieldTouched(name, true, true);
  }, [isSubmitting, name, setFieldTouched]);

  const processedOptions = useMemo(
    () => options.map((option: RadioOption) => (typeof option === "string" ? { label: option, value: option } : option)),
    [options]
  );

  return (
    <div className={`w-full flex flex-column`}>
      {label && (
        <label htmlFor={name} className={`mb-2${rest.fieldLabelClassName}`}>
          {label}
        </label>
      )}

      <div className="flex">
        <Field
          name={name}
          render={({ field, form }: any) => (
            <>
              {processedOptions.map((option: RadioOption) => (
                <div key={String(option.value)} className={`flex align-items-center flex-row ${rest.fieldClassName}`}>
                  {label && (
                    <label htmlFor={`${name}_${String(option.value)}`} className="mx-2 mt-0">
                      {option.label}
                    </label>
                  )}
                  <RadioButton
                    className="cursor-pointer radio-btn"
                    {...field}
                    {...rest}
                    inputId={`${name}_${String(option.value)}`}
                    value={option.value}
                    checked={rest.value === option.value}
                    onChange={(e) => form.setFieldValue(name, e.value)}
                  />
                </div>
              ))}
            </>
          )}
        />
      </div>

      <ErrorMessage name={name} render={(msg) => <div className="error">{msg}</div>} />
    </div>
  );
};

export default RadioButtonComponent;
